import react from "react";
import { textTranslations } from "./footer/text-translations";
import { useLanguage } from "./LanguageContext";

const Footer = (props) => {

    const { language } = useLanguage();

    return (
        <footer className={props.fixed ? "footer fixed-footer" : "footer"}>
            <p>
            {textTranslations("main", language)}<br className="break-on-mobile" />
            🐘 <span style={{ color: "#fff" }} className="pretty-link" onClick={() => window.open("/privacy-policy", "_self")}>{textTranslations("privacy-policy", language)}</span>
            <span style={{ margin: "5px", color: "#fff" }}>| <a href="https://theboggler.com/blogs" style={{ color: "#fff" }} className="pretty-link"> ✏️ Blogs ✏️</a> |</span>
            <span style={{ color: "#fff" }} className="pretty-link" onClick={() => window.open("/terms-of-use", "_self")}>{textTranslations("terms-of-use", language)}</span> 🐘
            </p>
        </footer>
    );
}

export default Footer;